import { CheckboxProps } from '../..';

type AccordionCheckboxProps = Omit<CheckboxProps, 'hideLabel'>;

//common functions used in radio-accordion and checkbox-accordion

export const updateBoxState = (
  isChecked: boolean
): ((current: AccordionCheckboxProps[]) => AccordionCheckboxProps[]) => {
  return (current: AccordionCheckboxProps[]) => {
    return current.map((box) => {
      return { ...box, isChecked: isChecked };
    });
  };
};

export const defaultFunction = () => {
  return;
};
